import { Link } from "react-router-dom";
import { useLang } from "../LanguageContext";
import { translations } from "../data/translations";

export default function Footer() {
  const { lang } = useLang();
  const t = translations[lang];

  return (
    <footer className="bg-slate-950 text-white border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-lg font-semibold tracking-wide text-white mb-3">
              FUM DA
            </h3>
            <p className="text-sm text-slate-300 leading-6">
              {t.footer?.brandDescription}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-400 mb-4">
              {t.footer?.navigationTitle || "Navigation"}
            </h4>

            <div className="flex flex-col gap-2 text-sm">
              <a href="/#home" className="text-slate-300 hover:text-white transition">
                {t.nav?.home}
              </a>
              <a href="/#products" className="text-slate-300 hover:text-white transition">
                {t.nav?.products}
              </a>
              <a
                href="/#industrial-psu"
                className="text-slate-300 hover:text-white transition"
              >
                {t.nav?.industrialPsu}
              </a>
              <a
                href="/#rack-rails"
                className="text-slate-300 hover:text-white transition"
              >
                {t.nav?.rackRails}
              </a>
              <a href="/#about" className="text-slate-300 hover:text-white transition">
                {t.nav?.about}
              </a>
              <a href="/#contact" className="text-slate-300 hover:text-white transition">
                {t.nav?.contact}
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-400 mb-4">
              {t.footer?.legalTitle || "Legal"}
            </h4>

            <div className="flex flex-col gap-2 text-sm">
              <Link
                to="/impressum"
                className="text-slate-300 hover:text-white transition"
              >
                {t.footer?.impressum || "Impressum"}
              </Link>

              <Link
                to="/datenschutz"
                className="text-slate-300 hover:text-white transition"
              >
                {t.footer?.datenschutz || "Datenschutz"}
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm text-slate-400">
            © 2026 FUM DA. {t.footer?.rights}
          </p>

          <div className="flex items-center gap-5 text-sm">
            <Link
              to="/impressum"
              className="text-slate-400 hover:text-white transition"
            >
              {t.footer?.impressum || "Impressum"}
            </Link>

            <Link
              to="/datenschutz"
              className="text-slate-400 hover:text-white transition"
            >
              {t.footer?.datenschutz || "Datenschutz"}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
